import React from 'react'
import { ListItem, Text, UnorderedList, VStack } from '@chakra-ui/react'
import FooterInfoLayout from '@layouts/footer-info-layout'
import { TermsAndConditionsContent } from '@components/footer/terms-and-conditions'
import RouterUrl from '@constants/router.constant'

const EXCLUSIONS = [
  'Hygiene or perishable products (e.g., Innerwear & Cosmetic) unless otherwise stated/advertised',
  'Products on clearance (e.g., Campaigns: Lowest Price)',
  'Altered or modified products',
  'Products with unauthorized repairs',
  'Products with misuse/unethical damage',
  'Non-electrical products',
  'Stains, discolouration, and scratches due to normal wear and tear'
]

const WarrantyDirect = () => {
  return (
    <FooterInfoLayout
      title="Warranty Information - Direct Purchases"
      breadcrumbs={[
        { label: 'Home', href: RouterUrl.HOME.ROOT },
        { label: 'Warranty', href: RouterUrl.WARRANTY },
        { label: 'JML Direct Purchase' }
      ]}
    >
      <VStack spacing={8} w={'100%'} align={'start'}>
        <TermsAndConditionsContent>
          Thank You For Shopping With JML!
        </TermsAndConditionsContent>

        <Text w={'100%'} color={'red'} fontWeight={600}>
          Warranty coverage is not valid for non-electrical products.
        </Text>

        <TermsAndConditionsContent>
          For your convenience, you do not need to register your warranty since
          you have purchased directly from us. Your warranty is automatically
          registered in our system upon purchase.
        </TermsAndConditionsContent>

        <TermsAndConditionsContent title="Product Warranty">
          JML Singapore Pte Ltd provides a product warranty for a period of
          twelve (12) months from the date of purchase, covering defects in
          workmanship and materials. The warranty is non-transferable and valid
          only in Singapore, and only covers electrical products with an
          electrical plug (excluding USB-powered/charged products).
        </TermsAndConditionsContent>

        <TermsAndConditionsContent title="14 Days Replacement">
          In the event of incomplete, defective, or damaged goods in transit,
          you are entitled to a replacement or exchange within 14 days from the
          receiving date. Please visit our service centre during office hours
          (Monday to Friday, 9 am to 6 pm, avoid lunch time 1 pm - 2 pm),
          strictly by appointment, with the original packaging and proof of
          purchase.
        </TermsAndConditionsContent>

        <TermsAndConditionsContent title="This warranty does not apply to:">
          <UnorderedList w={'100%'} pl={5}>
            {EXCLUSIONS.map((item, k) => (
              <ListItem key={k}>{item}</ListItem>
            ))}
          </UnorderedList>
        </TermsAndConditionsContent>

        <TermsAndConditionsContent>
          JML Singapore Pte Ltd will take no liability or claims for any damages
          caused due to the customer&apos;s individual negligence. Customers
          should read the user manual before using the product correctly. This
          warranty does not affect your statutory rights.
        </TermsAndConditionsContent>
      </VStack>
    </FooterInfoLayout>
  )
}

export default WarrantyDirect
